<!-- eslint-disable vue/no-v-html -->
<template>
  <p v-if="isHtml" v-html="provideSanitized(text)" />
  <p v-else>{{ text }}</p>
</template>

<script setup lang="ts">
  interface IProps {
    text?: string;
    isHtml?: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    text: '',
    isHtml: false,
  });
</script>
